<h1>Resgatar senha</h1>
<input type="text" placeholder="digite seu email">
<button (click)="Enviar()">Enviar-Sucesso</button>
